var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2H4.4C3.07452 2 2 3.07452 2 4.4V12.8C2 14.1255 3.07452 15.2 4.4 15.2H12.8C14.1255 15.2 15.2 14.1255 15.2 12.8V4.4C15.2 3.07452 14.1255 2 12.8 2Z",
    fill: "#E6C156"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6008 2H21.2008C19.8753 2 18.8008 3.07452 18.8008 4.4V12.8C18.8008 14.1255 19.8753 15.2 21.2008 15.2H29.6008C30.9263 15.2 32.0008 14.1255 32.0008 12.8V4.4C32.0008 3.07452 30.9263 2 29.6008 2Z",
    fill: "#E6C156"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 18.7998H4.4C3.07452 18.7998 2 19.8743 2 21.1998V29.5998C2 30.9253 3.07452 31.9998 4.4 31.9998H12.8C14.1255 31.9998 15.2 30.9253 15.2 29.5998V21.1998C15.2 19.8743 14.1255 18.7998 12.8 18.7998Z",
    fill: "#E6C156"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4008 31.9998C29.0459 31.9998 32.0008 29.0449 32.0008 25.3998C32.0008 21.7547 29.0459 18.7998 25.4008 18.7998C21.7557 18.7998 18.8008 21.7547 18.8008 25.3998C18.8008 29.0449 21.7557 31.9998 25.4008 31.9998Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/Categories.41b7dee869072b4459ac3b5a475251fe.svg";
export { ForwardRef as ReactComponent };